import React, { FC, useCallback } from 'react';
import connect from './connect';
import Form from './Form';
import { handleFormSubmitted } from './logic';
import { Props } from './types';

const SearchOptions: FC<Props> = ({
  hash,
  pathname,
  replace,
  search,
  ...rest
}) => {
  const onSubmit = useCallback(
    handleFormSubmitted({
      hash,
      pathname,
      replace,
      search,
    }),
    [hash, pathname, replace, search],
  );

  return <Form onSubmit={onSubmit} {...rest} />;
};

export default connect(SearchOptions);
